import Svg, { Circle, Path, Rect } from 'react-native-svg';

// The brand mark, ported from landing/logo-mark.svg -- same geometry,
// same two brand colors (ink card, stamp seal). Colors are intentionally
// fixed rather than themed: the mark's identity (a dark card with a red
// wax seal) doesn't invert for dark mode any more than a printed logo
// would, matching how landing/index.html uses it identically in both
// contexts (it has no dark mode of its own).
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label="Nearkin">
      <Rect
        x={18}
        y={14}
        width={54}
        height={68}
        rx={7}
        fill="#24291F"
        stroke="#EDE7D9"
        strokeWidth={1.5}
        transform="rotate(-6 45 48)"
      />
      <Path
        d="M 92.80 79.00 L 90.60 82.56 L 91.04 86.72 L 87.51 88.98 L 86.10 92.92 L 81.94 93.42 L 78.96 96.35 L 75.00 95.00 L 71.04 96.35 L 68.06 93.42 L 63.90 92.92 L 62.49 88.98 L 58.96 86.72 L 59.40 82.56 L 57.20 79.00 L 59.40 75.44 L 58.96 71.28 L 62.49 69.02 L 63.90 65.08 L 68.06 64.58 L 71.04 61.65 L 75.00 63.00 L 78.96 61.65 L 81.94 64.58 L 86.10 65.08 L 87.51 69.02 L 91.04 71.28 L 90.60 75.44 L 92.80 79.00 Z"
        fill="#A73B2E"
      />
      <Circle cx={75} cy={79} r={6.5} fill="none" stroke="#EDE7D9" strokeWidth={1.6} />
    </Svg>
  );
}
